module.exports = __webpack_public_path__ + "img/arrow-down-gray.55703a28.svg";